<!--
  DEUDA TÉCNICA: quedan tres flags deprecados en IModalConfig, que se eliminan cuando los
  callers dejen de usarlos: `showGenericMessage` tiene su texto hardcodeado acá abajo,
  `hideTitle` se reemplaza por no mandar título, y `stopRedirect` por la `route` de cada action.
  Junto con ellos se van los getters `heading` y `body`, que hoy existen solo para que los
  errores sin título se sigan viendo como antes.
-->
<div class="wrapper">
  <div class="center">
    <img [src]="icon.src" [attr.width]="icon.width" [attr.height]="icon.height" alt="" />

    <h1 *ngIf="!!heading" [ngClass]="{ 'subtitle-margin': !!data.subtitle }" [innerHTML]="heading"></h1>

    <h4 *ngIf="!!data.subtitle" class="subtitle" [innerHTML]="data.subtitle"></h4>

    <p *ngIf="!!data.expNro" class="reference">Trámite <strong>N° {{ data.expNro }}</strong></p>

    <p
      *ngIf="!!body"
      [class.highlight]="data.highlightText"
      [class.texto]="data.type === 'more-info'"
      [ngClass]="{ 'mt-2': data.hideTitle }"
      [innerHTML]="body"></p>

    <p *ngIf="data.showGenericMessage">
      Seguí la gestión a través de nuestra app o <br />
      desde la <a [routerLink]="['/dashboard/notificaciones']" mat-dialog-close>bandeja de entrada</a> de
      <strong>Notificaciones</strong> <br />
      de esta plataforma.
    </p>

    <nobis-button *ngFor="let action of actions" (click)="onAction(action)">
      {{ action.label }}
    </nobis-button>
  </div>
</div>
